import { Controller } from "@hotwired/stimulus"

// Autocomplete tagging box for assigning US states. Type to filter the
// remaining states; selected states render as removable chips backed by hidden
// inputs. Pre-populates from the `selected` value on connect (edit form).
export default class extends Controller {
  static targets = ["input", "results", "chips", "hidden"]
  static values = {
    options: Array,  // [[name, code], ...]
    selected: Array, // ["US-CA", ...]
    name: String     // hidden input name, e.g. "task[assigned_states][]"
  }

  connect() {
    this.options = this.optionsValue.map(([name, code]) => ({ name, code }))
    this.namesByCode = new Map(this.options.map(o => [o.code, o.name]))
    this.selected = new Set(this.selectedValue)
    this.renderChips()
  }

  filter() {
    const query = this.inputTarget.value.trim().toLowerCase()
    if (query === "") return this.hideResults()

    const matches = this.options.filter(o =>
      !this.selected.has(o.code) && o.name.toLowerCase().includes(query)
    )
    this.renderResults(matches)
  }

  select(event) {
    this.selected.add(event.currentTarget.dataset.code)
    this.inputTarget.value = ""
    this.hideResults()
    this.renderChips()
    this.inputTarget.focus()
  }

  remove(event) {
    event.preventDefault()
    this.selected.delete(event.currentTarget.dataset.code)
    this.renderChips()
  }

  closeOnOutside(event) {
    if (!this.element.contains(event.target)) this.hideResults()
  }

  keydown(event) {
    if (event.key === "Escape") this.hideResults()
  }

  renderChips() {
    this.chipsTarget.innerHTML = ""
    this.hiddenTarget.innerHTML = ""

    this.selected.forEach(code => {
      const name = this.namesByCode.get(code) || code

      const chip = document.createElement("span")
      chip.className = "chip"
      chip.innerHTML = `${name} <button type="button" class="chip-remove" data-action="click->states-select#remove" data-code="${code}" aria-label="Remove ${name}">&times;</button>`
      this.chipsTarget.appendChild(chip)

      const input = document.createElement("input")
      input.type = "hidden"
      input.name = this.nameValue
      input.value = code
      this.hiddenTarget.appendChild(input)
    })
  }

  renderResults(matches) {
    this.resultsTarget.innerHTML = ""
    if (matches.length === 0) return this.hideResults()

    matches.slice(0, 8).forEach(o => {
      const row = document.createElement("button")
      row.type = "button"
      row.className = "search-result w-full text-left"
      row.textContent = o.name
      row.dataset.code = o.code
      row.dataset.action = "click->states-select#select"
      this.resultsTarget.appendChild(row)
    })
    this.resultsTarget.classList.remove("hidden")
  }

  hideResults() {
    this.resultsTarget.classList.add("hidden")
    this.resultsTarget.innerHTML = ""
  }
}
